import { render, staticRenderFns } from "./AIRecognition.vue?vue&type=template&id=ec86127e&scoped=true&"
import script from "./AIRecognition.vue?vue&type=script&lang=js&"
export * from "./AIRecognition.vue?vue&type=script&lang=js&"
import style0 from "./AIRecognition.vue?vue&type=style&index=0&id=ec86127e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec86127e",
  null
  
)

export default component.exports